import { BASE_URL } from "../../configuration/apiconfig";
import UserStore from "../../store/UserStore";
import axios from "axios";
import API from "../../api/api";

export default class Ifern4pService {
  key = localStorage.getItem("apiKey");
  //4p code generator
  register = async (data) => {
    try {
      const response = await API.API.post("four-p/check-code", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        return response
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  generateCode = async (data) => {
    try {
      const response = await API.API.post("four-p/generate-code", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  //4p registration
  four_P_Register = async (data) => {
    try {
      const response = await API.API.post("four-p/fourp-registration", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  Ifern4p = async () => {
    return await API.API.get("four-p/fourp-tile")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };

  //Current user activation code history
  activatedList = async (
    start = 0,
    length = 10,
    direction = "",
    startDate = "",
    endDate = "",
    keys = "",
    order = ""
  ) => {
    return await API.API.get(
      "four-p/fourp-activation-code-history?" +
      direction +
      "&length=" +
      length +
      "&start=" +
      start +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate +
      "&order=" +
      keys +
      "&type=" +
      order
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };

  //reorder activation
  fourpReorderActivation = async (data) => {
    try {
      const response = await API.API.post("four-p/fourp-reorder", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  //Downline activation history
  history = async (
    start = 0,
    length = 10,
    direction = "",
    startDate = "",
    endDate = "",
    keys = "",
    order = ""
  ) => {
    return await API.API.get(
      "four-p/fourp-downline-activation-list?direction=" +
      direction +
      "&length=" +
      length +
      "&start=" +
      start +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate +
      "&order=" +
      keys +
      "&type=" +
      order
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  gsrcode = async (data) => {
    try {
      const response = await API.API.post("four-p/fourp-reorder", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Request failed");
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  // wallet = async (start, length) => {
  //   return await API.API.get('ifern4p/purchase_wallet_table?length=' + length + '&start=' + start + '')
  //     .then((res) => {
  //       if (res.status === 200) {
  //         return res.data
  //       }
  //       else {
  //         return res;
  //       }
  //     }).catch((error) => console.log(error))
  // }
  // earnigs = async (start = 0, length = 10, direction = "", startDate = "", endDate = "", keys = "", order = "") => {
  //   return await API.API.get('four-p/fourp-activated-list?direction=' + direction + '&length=' + length + '&start=' + start + '&start_date=' + startDate + '&end_date=' + endDate + '&order=' + order)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         return res.data
  //       }
  //       else {
  //         return res;
  //       }
  //     }).catch((error) => console.log(error))
  // }
  // fundTransfer = async (payload) => {
  //   return await API.API.post('ifern4p/fund_transfer', payload)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         return res.data
  //       }
  //       else {
  //         return res;
  //       }
  //     }).catch((error) => console.log(error))
  // }
  // exportData = async (startDate = "", endDate = "", keys = "", type = "") => {
  //   return await API.API.get('ifern4p/earnings_export_data?type=' + type + '&start_date=' + startDate + '&end_date=' + endDate + '&' + keys)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         return res.data
  //       }
  //       else {
  //         return res;
  //       }
  //     }).catch((error) => console.log(error))
  // }

  //Export user activation code history data
  async exportDataHistory(startDate = "", endDate = "", keys = "", type = "") {
    const response = await fetch(
      BASE_URL +
      "four-p/export-fourp-activation-code-history?type=" +
      type +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate +
      "&" +
      keys,
      {
        method: "GET", //method
        headers: {
          //passing header
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return response.json();
  }

  //Export downline activation code details
  async exportData(startDate = "", endDate = "", keys = "", type = "") {
    const response = await fetch(
      BASE_URL +
      "four-p/export-fourp-downline-activation-list?type=" +
      type +
      "&start_date=" +
      startDate +
      "&end_date=" +
      endDate +
      "&" +
      keys,
      {
        method: "GET", //method
        headers: {
          //passing header
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return response.json();
  }

  async singleCodeListHistory(id) {
    const response = await fetch(
      BASE_URL + `four-p/fourp-activation-code-history/${id}`,
      {
        method: "GET", //method
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return response.json();
  }

  //get fourp account currentmonth maintenance data
  getFourpMaintenanceAmount = async (data) => {
    try {
      const response = await API.API.post(
        "four-p/get-forup-monthly-maintenance",
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };
}
